<template>
  <div class="pa-3 ma-3">
    <!-- Alertas -->
    <v-alert-dialog ref="alert"></v-alert-dialog>

    <v-dialog
      v-model="dialogValidate"
      persistent
      max-width="80%"
    >
      <v-card class="dialog-card">
        <!-- Header minimalista -->
        <v-card-title class="px-6 py-4">
          <div class="d-flex align-center justify-space-between w-100">
            <div>
              <div class="text-h6 font-weight-medium mb-1">Validación de Factura y Evidencia</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="px-6 py-5">
          <v-row>
            <!-- Información General -->

            <v-col cols="12" md="6" class="py-0">
              <div class="info-field">
                <div class="info-label"># Orden de Programación de Pago:</div>
                <div class="info-value">
                  <div>{{ validateItem.clave }}</div>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <div class="info-field">
                <div class="info-label">Concepto</div>
                <div class="info-value">
                  <strong>{{ validateItem.nombre_gasto_tipo }}</strong>
                  <span class="grey--text text--darken-1"> • {{ validateItem.nombre_gasto_subtipo }}</span>
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <div class="info-field">
                <div class="info-label">Monto</div>
                <div class="info-value font-weight-medium">
                  {{validateItem.simbolo_moneda}} {{ formatMoney(getTotal(validateItem)) }} {{validateItem.clave_moneda}}
                </div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <div class="info-field">
                <div class="info-label"># Pago</div>
                <div class="info-value">
                  {{ validateItem.no_factura }} de {{ validateItem.num_facturas }}
                </div>
              </div>
            </v-col>

            <v-col cols="12" class="py-0" v-if="validateItem.descripcion">
              <div class="info-field">
                <div class="info-label">Descripción</div>
                <div class="info-value">{{ validateItem.descripcion }}</div>
              </div>
            </v-col>

            <v-col cols="12" class="py-0" v-if="validateItem.archivo_cotizacion">
              <div class="info-field">
                <div class="info-label">Archivo de Cotización/Presupuesto</div>
                <v-viewer
                  v-model="validateItem.archivo_cotizacion"
                  label="Archivo de Cotización/Presupuesto"
                  url-base="/api/Pagos/DescargarProgramacionCompraOrdenDocumento"
                />
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0" v-if="validateItem.numero_facturas > 1">
              <div class="info-field">
                <div class="info-label">Intervalo de Facturación</div>
                <div class="info-value">{{ validateItem.nombre_intervalo }}</div>
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0" v-if="validateItem.numero_facturas > 1">
              <div class="info-field">
                <div class="info-label">Fecha de Inicio</div>
                <div class="info-value">{{ validateItem.fecha_inicio }}</div>
              </div>
            </v-col>

            <!-- Proveedor -->
            <v-col cols="12" class="pb-0 mb-0 text-center">
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon>mdi-truck</v-icon>
                Proveedor
              </div>
            </v-col>

            <v-col cols="12">
              <v-row dense>
                <v-col cols="3">
                  <div class="info-field">
                    <div class="info-label">Clave</div>
                    <div class="info-value">{{ validateItem.codigo_proveedor }}</div>
                  </div>
                </v-col>

                <v-col cols="3">
                  <div class="info-field">
                    <div class="info-label">Tipo de Proveedor</div>
                    <div class="info-value">{{ validateItem.tipo_proveedor }}</div>
                  </div>
                </v-col>

                <v-col cols="3">
                  <div class="info-field">
                    <div class="info-label">Tipo de Persona</div>
                    <div class="info-value">{{ validateItem.persona_tipo }}</div>
                  </div>
                </v-col>

                <v-col cols="3">
                  <div class="info-field">
                    <div class="info-label">Nombre Comercial</div>
                    <div class="info-value">{{ validateItem.nombre_proveedor }}</div>
                  </div>
                </v-col>
              </v-row>
            </v-col>

            <!-- Documentos -->
            <v-col cols="12" class="pa-0 ma-0 text-center mb-2">
              <div class="text-subtitle-1 font-weight-bold">
                <v-icon small class="mr-2">mdi-file-document</v-icon>
                Documentos
              </div>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <v-card 
                flat 
                outlined 
                class="document-card"
                :class="{ 'document-card--reviewed': facturaRevisada }"
              >
                <v-card-text class="pa-4">
                  <div class="d-flex align-center justify-space-between mb-3">
                    <div class="d-flex align-center">
                      <v-icon
                        class="mr-2"
                        :color="
                          !facturaValidacionCompleta
                            ? 'grey'
                            : (tieneRespuestasNegativasFactura ? 'warning' : 'success')
                        "
                      >
                        {{
                          !facturaValidacionCompleta
                            ? 'mdi-file-document-outline'
                            : (tieneRespuestasNegativasFactura ? 'mdi-alert-circle' : 'mdi-check-circle')
                        }}
                      </v-icon>

                      <div>
                        <div class="font-weight-medium">Factura</div>
                        <div class="text-caption grey--text">
                          {{
                            !facturaValidacionCompleta
                              ? 'Pendiente de revisión'
                              : (tieneRespuestasNegativasFactura
                                  ? 'Revisión completa con observaciones'
                                  : 'Revisión completa')
                          }}
                        </div>
                      </div>
                    </div>

                    <v-chip
                      small
                      :color="facturaRevisada ? 'success' : 'grey'"
                      :outlined="!facturaRevisada"
                      class="status-chip"
                    >
                      {{ facturaRevisada ? 'Revisada' : 'Pendiente' }}
                    </v-chip>
                  </div>
                  <v-btn
                    block
                    outlined
                    :color="facturaRevisada ? 'success' : 'primary'"
                    @click="openDialogFactura"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Ver Factura
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" md="6" class="py-0">
              <v-card 
                flat 
                outlined 
                class="document-card"
                :class="{ 'document-card--reviewed': evidenciaRevisada }"
              >
                <v-card-text class="pa-4">
                  <div class="d-flex align-center justify-space-between mb-3">
                    <div class="d-flex align-center">
                      <v-icon
                        class="mr-2"
                        :color="
                          !evidenciaValidacionCompleta
                            ? 'grey'
                            : (tieneRespuestasNegativas ? 'warning' : 'success')
                        "
                      >
                        {{
                          !evidenciaValidacionCompleta
                            ? 'mdi-clipboard-file-outline'
                            : (tieneRespuestasNegativas ? 'mdi-alert-circle' : 'mdi-check-circle')
                        }}
                      </v-icon>

                      <div>
                        <div class="font-weight-medium">Evidencia</div>
                        <div class="text-caption grey--text">
                          {{
                            !evidenciaValidacionCompleta
                              ? 'Pendiente de revisión'
                              : (tieneRespuestasNegativas
                                  ? 'Revisión completa con observaciones'
                                  : 'Revisión completa')
                          }}
                        </div>
                      </div>
                    </div>
                    <v-chip
                      small
                      :color="evidenciaRevisada ? 'success' : 'grey'"
                      :outlined="!evidenciaRevisada"
                      class="status-chip"
                    >
                      {{ evidenciaRevisada ? 'Revisada' : 'Pendiente' }}
                    </v-chip>
                  </div>
                  <v-btn
                    block
                    outlined
                    :color="evidenciaRevisada ? 'success' : 'primary'"
                    @click="openDialogEvidencia"
                  >
                    <v-icon left small>mdi-eye</v-icon>
                    Ver Evidencia
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col cols="12" v-if="(tieneRespuestasNegativas || tieneRespuestasNegativasFactura) && evidenciaValidacionCompleta && facturaValidacionCompleta">
              <v-alert type="error" dense text class="text-caption mt-2 mb-3">
                <div class="font-weight-medium mb-1">
                  Se detectaron observaciones en
                  <strong>
                    {{
                      (tieneRespuestasNegativasFactura && tieneRespuestasNegativas)
                        ? 'Factura y Evidencia'
                        : (tieneRespuestasNegativasFactura ? 'Factura' : 'Evidencia')
                    }}
                  </strong>
                </div>

                <div>
                  Debido a que se han encontrado observaciones, la <strong>Orden de Programación de Pago</strong> será <strong>rechazada</strong>.
                  Por favor, registre una <strong>observación</strong> o <strong>comentario</strong> indicando el motivo del rechazo.
                </div>
              </v-alert>

              <v-textarea
                v-model="rechazo_comentarios"
                label="Observaciones / Comentarios de rechazo"
                placeholder="Describe brevemente el motivo del rechazo (qué se encontró y qué debe corregirse)."
                outlined
                dense
                rows="1"
                auto-grow
              />
            </v-col>

            <!-- Dialog Factura -->
            <v-dialog
              v-model="dialogFactura"
              fullscreen
              transition="dialog-bottom-transition"
              content-class="factura-dialog"
            >
              <v-card class="factura-card">
                <v-toolbar dark color="primary" class="factura-toolbar">
                  <v-btn icon @click="closeDialogFactura">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title class="font-weight-medium">
                    Factura
                  </v-toolbar-title>
                </v-toolbar>

                <!-- ESTE es el único que scrollea -->
                <div class="factura-body">
                  <div class="opp-scroll-x">
                    <v-row class="ma-0">
                      <!-- Columna de validación -->
                      <v-col cols="2" class="border-right validation-panel validation-col">
                        <div class="text-subtitle-2 font-weight-medium mb-4">Validación de Factura</div>
                        
                        <!-- Validaciones condicionales -->
                        <div class="validation-section mb-4">
                          <div class="text-caption grey--text mb-3">Verificar importes:</div>
                          
                          <!-- Validación IVA -->
                          <div v-if="validateItem.iva > 0" class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <div class="validation-label flex-grow-1">
                                <div class="text-caption font-weight-medium">IVA ({{ validateItem.iva }}%)</div>
                                <div class="text-caption font-weight-bold primary--text">
                                  {{ validateItem.simbolo_moneda }} {{ formatMoney(getIva(validateItem)) }}
                                </div>
                              </div>
                            </div>
                            <v-btn-toggle
                              v-model="validaciones.ivaCoincide"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validaciones.ivaCoincide !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validaciones.ivaCoincide !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación ISR -->
                          <div v-if="validateItem.isr > 0" class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <div class="validation-label flex-grow-1">
                                <div class="text-caption font-weight-medium">ISR Ret. ({{ validateItem.isr }}%)</div>
                                <div class="text-caption font-weight-bold error--text">
                                  {{ validateItem.simbolo_moneda }} {{ formatMoney(getIsr(validateItem)) }}
                                </div>
                              </div>
                            </div>
                            <v-btn-toggle
                              v-model="validaciones.isrCoincide"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validaciones.isrCoincide !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validaciones.isrCoincide !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación IVA Retención -->
                          <div v-if="validateItem.iva_retencion > 0" class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <div class="validation-label flex-grow-1">
                                <div class="text-caption font-weight-medium">IVA Ret. ({{ validateItem.iva_retencion }}%)</div>
                                <div class="text-caption font-weight-bold error--text">
                                  {{ validateItem.simbolo_moneda }} {{ formatMoney(getIvaRetencion(validateItem)) }}
                                </div>
                              </div>
                            </div>
                            <v-btn-toggle
                              v-model="validaciones.ivaRetencionCoincide"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validaciones.ivaRetencionCoincide !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validaciones.ivaRetencionCoincide !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación Total -->
                          <div class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <div class="validation-label flex-grow-1">
                                <div class="text-caption font-weight-medium">Total</div>
                                <div class="text-caption font-weight-bold success--text">
                                  {{ validateItem.simbolo_moneda }} {{ formatMoney(getTotal(validateItem)) }}
                                </div>
                              </div>
                            </div>
                            <v-btn-toggle
                              v-model="validaciones.totalCoincide"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validaciones.totalCoincide !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validaciones.totalCoincide !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <!-- Resumen de montos -->
                        <!--
                        <div class="amounts-summary mb-4">
                          <div class="text-caption grey--text mb-2">Desglose:</div>
                          <div class="d-flex justify-space-between text-caption mb-1">
                            <span>Subtotal:</span>
                            <span class="font-weight-medium">{{ validateItem.simbolo_moneda }} {{ formatMoney(validateItem.monto) }}</span>
                          </div>
                          <div v-if="validateItem.iva > 0" class="d-flex justify-space-between text-caption mb-1">
                            <span>+ IVA:</span>
                            <span class="font-weight-medium">{{ validateItem.simbolo_moneda }} {{ formatMoney(getIva(validateItem)) }}</span>
                          </div>
                          <div v-if="validateItem.isr > 0" class="d-flex justify-space-between text-caption mb-1">
                            <span>- ISR Ret.:</span>
                            <span class="font-weight-medium">{{ validateItem.simbolo_moneda }} {{ formatMoney(getIsr(validateItem)) }}</span>
                          </div>
                          <div v-if="validateItem.iva_retencion > 0" class="d-flex justify-space-between text-caption mb-1">
                            <span>- IVA Ret.:</span>
                            <span class="font-weight-medium">{{ validateItem.simbolo_moneda }} {{ formatMoney(getIvaRetencion(validateItem)) }}</span>
                          </div>
                          <v-divider class="my-2"></v-divider>
                          <div class="d-flex justify-space-between text-body-2">
                            <span class="font-weight-bold">Total:</span>
                            <span class="font-weight-bold success--text">{{ validateItem.simbolo_moneda }} {{ formatMoney(getTotal(validateItem)) }}</span>
                          </div>
                        </div>
                        -->

                        <!--
                        <v-divider class="my-3"></v-divider>
                        -->

                        <!-- Estado de validación -->
                        <v-alert
                          :type="
                            !facturaValidacionCompleta
                              ? 'info'
                              : (tieneRespuestasNegativasFactura ? 'warning' : 'success')
                          "
                          :color="
                            (!facturaValidacionCompleta)
                              ? undefined
                              : (tieneRespuestasNegativasFactura ? 'orange darken-2' : undefined)
                          "
                          dense
                          text
                          class="text-caption mt-2"
                        >
                          <div class="d-flex align-center">
                            <span>
                              {{
                                !facturaValidacionCompleta
                                  ? 'Pendiente de revisar'
                                  : (tieneRespuestasNegativasFactura
                                      ? 'Revisión completa con observaciones'
                                      : 'Revisión completa')
                              }}
                            </span>
                          </div>
                        </v-alert>


                      </v-col>

                      <!-- Visor del documento -->
                      <v-col cols="10">
                        <div class="fill-height pa-4">
                          <!-- Loading -->
                          <div
                            v-if="loadingFactura"
                            class="d-flex flex-column align-center justify-center fill-height"
                          >
                            <v-progress-circular
                              indeterminate
                              :size="48"
                              :width="2"
                              color="primary"
                            ></v-progress-circular>
                            <span class="mt-4 text-body-2 grey--text">
                              Cargando documento...
                            </span>
                          </div>

                          <!-- Error -->
                          <div
                            v-else-if="loadFacturaError"
                            class="d-flex align-center justify-center fill-height"
                          >
                            <div class="text-center">
                              <v-icon size="48" color="error">mdi-alert-circle-outline</v-icon>
                              <div class="mt-2 text-body-2 error--text">
                                {{ loadFacturaError }}
                              </div>
                            </div>
                          </div>

                          <!-- PDF -->
                          <div
                            v-else-if="showFacturaPDF && urlFactura"
                            class="pdf-container"
                          >
                            <vue-pdf-embed
                              class="pdf-viewer"
                              :source="urlFactura"
                            />
                          </div>

                          <!-- Imagen -->
                          <div v-else-if="urlFactura" class="text-center">
                            <v-img
                              :src="urlFactura"
                              contain
                              max-height="85vh"
                            ></v-img>
                          </div>

                          <!-- Sin archivo -->
                          <div
                            v-else
                            class="d-flex align-center justify-center fill-height"
                          >
                            <div class="text-center">
                              <v-icon size="48" color="grey">mdi-file-document-outline</v-icon>
                              <div class="mt-2 text-body-2 grey--text">
                                No hay archivo para visualizar
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </v-dialog>

            <!-- Dialog Evidencia -->
            <v-dialog
              v-model="dialogEvidencia"
              fullscreen
              transition="dialog-bottom-transition"
              content-class="evidencia-dialog"
            >
              <v-card class="evidencia-card">
                <v-toolbar dark color="primary" class="evidencia-toolbar">
                  <v-btn icon @click="closeDialogEvidencia">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <v-toolbar-title class="font-weight-medium">
                    Evidencia
                  </v-toolbar-title>
                </v-toolbar>

                <!-- Único scroll vertical -->
                <div class="evidencia-body">
                  <div class="opp-scroll-x">
                    <v-row class="ma-0 fill-height">
                      <!-- Columna de validación -->
                      <v-col cols="2" class="border-right pa-4 validation-panel validation-col">
                        <div class="text-subtitle-2 font-weight-medium mb-4">Validación de Evidencia</div>
                        
                        <!-- Validaciones de evidencia -->
                        <div class="validation-section mb-4">
                          <div class="text-caption grey--text mb-3">Verificar que la evidencia:</div>
                          
                          <!-- Validación de legibilidad -->
                          <div class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <v-icon small class="mr-2" color="primary">mdi-eye-check</v-icon>
                              <span class="text-caption font-weight-medium">Es legible y de buena calidad</span>
                            </div>
                            <v-btn-toggle
                              v-model="validacionesEvidencia.esLegible"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validacionesEvidencia.esLegible !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validacionesEvidencia.esLegible !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación de correspondencia -->
                          <div class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <v-icon small class="mr-2" color="primary">mdi-check-decagram</v-icon>
                              <span class="text-caption font-weight-medium">Corresponde a la factura/orden de pago</span>
                            </div>
                            <v-btn-toggle
                              v-model="validacionesEvidencia.correspondeFactura"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validacionesEvidencia.correspondeFactura !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validacionesEvidencia.correspondeFactura !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación de completitud -->
                          <div class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <v-icon small class="mr-2" color="primary">mdi-file-check</v-icon>
                              <span class="text-caption font-weight-medium">Está completa (incluye toda la información necesaria)</span>
                            </div>
                            <v-btn-toggle
                              v-model="validacionesEvidencia.estaCompleta"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validacionesEvidencia.estaCompleta !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validacionesEvidencia.estaCompleta !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>

                          <!-- Validación de autenticidad -->
                          <div class="validation-item mb-3">
                            <div class="d-flex align-center mb-2">
                              <v-icon small class="mr-2" color="primary">mdi-shield-check</v-icon>
                              <span class="text-caption font-weight-medium">No presenta alteraciones o modificaciones</span>
                            </div>
                            <v-btn-toggle
                              v-model="validacionesEvidencia.sinAlteraciones"
                              dense
                              rounded
                              class="validation-toggle"
                            >
                              <v-btn
                                small
                                :value="1"
                                color="success"
                                :outlined="validacionesEvidencia.sinAlteraciones !== 1"
                              >
                                <v-icon small left>mdi-check</v-icon>
                                Sí
                              </v-btn>
                              <v-btn
                                small
                                :value="0"
                                color="error"
                                :outlined="validacionesEvidencia.sinAlteraciones !== 0"
                              >
                                <v-icon small left>mdi-close</v-icon>
                                No
                              </v-btn>
                            </v-btn-toggle>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>

                        <!-- Información del documento -->
                        <!--
                        <div class="document-info mb-4">
                          <div class="text-caption grey--text mb-2">Información:</div>
                          <div class="info-item">
                            <v-icon x-small class="mr-1">mdi-calendar</v-icon>
                            <span class="text-caption">
                              <strong>Orden:</strong> {{ validateItem.clave }}
                            </span>
                          </div>
                          <div class="info-item mt-1">
                            <v-icon x-small class="mr-1">mdi-currency-usd</v-icon>
                            <span class="text-caption">
                              <strong>Monto:</strong> {{ validateItem.simbolo_moneda }} {{ formatMoney(getTotal(validateItem)) }}
                            </span>
                          </div>
                          <div class="info-item mt-1">
                            <v-icon x-small class="mr-1">mdi-account</v-icon>
                            <span class="text-caption">
                              <strong>Proveedor:</strong> {{ validateItem.nombre_proveedor }}
                            </span>
                          </div>
                        </div>

                        <v-divider class="my-3"></v-divider>
                        -->

                        <!-- Estado de validación -->
                        <v-alert
                          :type="
                            !evidenciaValidacionCompleta
                              ? 'info'
                              : (tieneRespuestasNegativas ? 'warning' : 'success')
                          "
                          :color="
                            (!evidenciaValidacionCompleta)
                              ? undefined
                              : (tieneRespuestasNegativas ? 'orange darken-2' : undefined)
                          "
                          dense
                          text
                          class="text-caption mt-2"
                        >
                          <div class="d-flex align-center">
                            <span>
                              {{
                                !evidenciaValidacionCompleta
                                  ? 'Pendiente de revisar'
                                  : (tieneRespuestasNegativas
                                      ? 'Revisión completa con observaciones'
                                      : 'Revisión completa')
                              }}
                            </span>
                          </div>
                        </v-alert>

                      </v-col>

                      <!-- Visor del documento -->
                      <v-col cols="10">
                        <div class="fill-height pa-4">
                          <!-- Loading -->
                          <div
                            v-if="loadingEvidencia"
                            class="d-flex flex-column align-center justify-center fill-height"
                          >
                            <v-progress-circular
                              indeterminate
                              :size="48"
                              :width="2"
                              color="primary"
                            ></v-progress-circular>
                            <span class="mt-4 text-body-2 grey--text">
                              Cargando documento...
                            </span>
                          </div>

                          <!-- Error -->
                          <div
                            v-else-if="loadEvidenciaError"
                            class="d-flex align-center justify-center fill-height"
                          >
                            <div class="text-center">
                              <v-icon size="48" color="error">mdi-alert-circle-outline</v-icon>
                              <div class="mt-2 text-body-2 error--text">
                                {{ loadEvidenciaError }}
                              </div>
                            </div>
                          </div>

                          <!-- PDF -->
                          <div
                            v-else-if="showEvidenciaPDF && urlEvidencia"
                            class="pdf-container"
                          >
                            <vue-pdf-embed
                              class="pdf-viewer"
                              :source="urlEvidencia"
                            />
                          </div>

                          <!-- Imagen -->
                          <div v-else-if="urlEvidencia" class="text-center">
                            <v-img
                              :src="urlEvidencia"
                              contain
                              max-height="85vh"
                            ></v-img>
                          </div>

                          <!-- Sin archivo -->
                          <div
                            v-else
                            class="d-flex align-center justify-center fill-height"
                          >
                            <div class="text-center">
                              <v-icon size="48" color="grey">mdi-clipboard-file-outline</v-icon>
                              <div class="mt-2 text-body-2 grey--text">
                                No hay archivo para visualizar
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </div>
                </div>
              </v-card>
            </v-dialog>

          </v-row>
        </v-card-text>

        <v-card-actions class="px-6 py-4">
          <v-btn
            text
            color="green"
            @click="closeDialogValidate"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="saveValidation"
            :disabled="!facturaRevisada || !evidenciaRevisada || saving"
          >
            Guardar Validación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="4">
        <v-text-field
          v-model="search.num_programacion_pago_orden"
          label="# Orden de Programación de Pago"
          clearable
          outlined
          dense
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete-proveedor
          v-model="search.id_proveedor"
          :items="proveedores"
          :loading="loadingProveedores"
        />
      </v-col>
      <v-col cols="12" md="4" >
        <v-btn color="primary" text outlined block @click="getItems">
          <v-icon> mdi-magnify </v-icon>
          Buscar
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :loading="loading"
        >
          <!-- Número de Orden -->
          <template v-slot:[`item.numero_orden`]="{ item }">
            {{ item.clave }}
          </template>

          <!-- Número de Pago -->
          <template v-slot:[`item.numero_pago`]="{ item }">
            {{ item.no_factura }} de {{ item.num_facturas }}
          </template>

          <template v-slot:[`item.concepto`]="{ item }">
            <strong>{{ item.nombre_gasto_tipo }}</strong> - {{ item.nombre_gasto_subtipo }}
          </template>

          <!-- Tipo de Proveedor -->
          <template v-slot:[`item.proveedor_nombre`]="{ item }">
            <div class="d-flex align-center">
              <div>
                <div class="text-caption">{{ item.nombre_proveedor }}</div>
                <div class="text-caption">{{ item.codigo_proveedor }} - {{item.tipo_proveedor}}</div>
              </div>
            </div>
          </template>

          <!-- Monto -->
          <template v-slot:[`item.monto`]="{ item }">
            {{item.simbolo_moneda}} {{ formatMoney(getTotal(item)) }} {{item.clave_moneda}}
          </template>

          <!-- Fecha habilitada -->
          <template v-slot:[`item.fecha_habilitada`]="{ item }">
            {{ item.fecha_habilitada_recepcion }}
          </template>

          <!-- Fecha de recepción -->
          <template v-slot:[`item.fecha_recepcion`]="{ item }">
            {{ item.fecha_carga_factura }}
          </template>

          <!-- Acciones -->
          <template v-slot:[`item.actions`]="{ item }">
            <!-- Validar Factura -->
            <v-tooltip
              bottom
              color="black"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  @click="openDialogValidate(item)"
                  small
                  class="mr-2"
                  >mdi-file-document-check</v-icon
                >
              </template>
              <span>Validar Factura y Evidencia</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import VAlertDialog from '@/components/VAlertDialog.vue'
import VAutocompleteProveedor from './VAutocompleteProveedor.vue'
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
  components:{
    VAlertDialog,
    VAutocompleteProveedor,
    VuePdfEmbed
  },
  computed: {
    ...mapState(['token']),
    
    // Computed para verificar si la validación de factura está completa
    facturaValidacionCompleta() {
      // Verificar que el total siempre esté respondido (diferente de null)
      if (this.validaciones.totalCoincide === null) return false;
      
      // Verificar IVA si es mayor a 0 (diferente de null)
      if (this.validateItem.iva > 0 && this.validaciones.ivaCoincide === null) return false;
      
      // Verificar ISR si es mayor a 0 (diferente de null)
      if (this.validateItem.isr > 0 && this.validaciones.isrCoincide === null) return false;
      
      // Verificar IVA Retención si es mayor a 0 (diferente de null)
      if (this.validateItem.iva_retencion > 0 && this.validaciones.ivaRetencionCoincide === null) return false;
      
      return true;
    },

    // Computed para verificar si hay respuestas negativas en factura
    tieneRespuestasNegativasFactura() {
      if (this.validaciones.totalCoincide === 0) return true;
      if (this.validateItem.iva > 0 && this.validaciones.ivaCoincide === 0) return true;
      if (this.validateItem.isr > 0 && this.validaciones.isrCoincide === 0) return true;
      if (this.validateItem.iva_retencion > 0 && this.validaciones.ivaRetencionCoincide === 0) return true;
      return false;
    },
    
    // Actualizar facturaRevisada basado en la Revisón completa
    facturaRevisada() {
      return this.facturaValidacionCompleta;
    },

    // Computed para verificar si la validación de evidencia está completa
    evidenciaValidacionCompleta() {
      // Todas las respuestas deben ser diferentes de null
      return this.validacionesEvidencia.esLegible !== null &&
             this.validacionesEvidencia.correspondeFactura !== null &&
             this.validacionesEvidencia.estaCompleta !== null &&
             this.validacionesEvidencia.sinAlteraciones !== null;
    },

    // Computed para verificar si hay respuestas negativas
    tieneRespuestasNegativas() {
      return this.validacionesEvidencia.esLegible === 0 ||
             this.validacionesEvidencia.correspondeFactura === 0 ||
             this.validacionesEvidencia.estaCompleta === 0 ||
             this.validacionesEvidencia.sinAlteraciones === 0;
    },

    // Actualizar evidenciaRevisada basado en la Revisón completa
    evidenciaRevisada() {
      return this.evidenciaValidacionCompleta;
    }
  },
  data: () => ({
    headers: [
      {
        text: "# Orden de Programación de Pago",
        value: "numero_orden",
        align: "center",
        width: "10%",
      },
      {
        text: "# Pago",
        value: "numero_pago",
        align: "center",
        width: "10%",
      },
      {
        text: "Proveedor",
        value: "proveedor_nombre",
        align: "left",
        width: "12%",
      },
      {
        text: "Concepto",
        value: "concepto",
        align: "left",
        width: "15%",
      },
      {
        text: "Monto",
        value: "monto",
        align: "center",
        width: "10%",
      },
      {
        text: "Fecha Habilitada",
        value: "fecha_habilitada",
        align: "center",
        width: "12%",
      },
      {
        text: "Fecha Recepción",
        value: "fecha_recepcion",
        align: "center",
        width: "12%",
      },
      {
        text: "Acciones",
        value: "actions",
        align: "center",
        width: "8%",
        sortable: false,
      },
    ],
    search: {
      num_programacion_pago_orden: null,
      id_proveedor: null,
    },

    loading: false,
    items: [],

    loadingProveedores: false,
    proveedores: [],

    validateItem: {
      id_programacion_compra_orden_factura: null,
      clave: "",
      no_factura: null,
      num_facturas: null,
      id_proveedor: "",
      nombre_proveedor: "",
      codigo_proveedor: "",
      tipo_proveedor: "",
      id_proveedor_tipo: "",
      persona_tipo: "",
      id_gasto_subtipo: "",
      nombre_gasto_subtipo: "",
      nombre_gasto_tipo: "",
      fecha_habilitada_recepcion: "",
      fecha_carga_factura: "",
      id_moneda: "",
      nombre_moneda: "",
      clave_moneda: "",
      simbolo_moneda: "",
      iva: null,
      isr: null,
      iva_retencion: null,
      monto: null
    },
    defaultValidateItem: {
      id_programacion_compra_orden_factura: null,
      clave: "",
      no_factura: null,
      num_facturas: null,
      id_proveedor: "",
      nombre_proveedor: "",
      codigo_proveedor: "",
      tipo_proveedor: "",
      id_proveedor_tipo: "",
      persona_tipo: "",
      id_gasto_subtipo: "",
      nombre_gasto_subtipo: "",
      nombre_gasto_tipo: "",
      fecha_habilitada_recepcion: "",
      fecha_carga_factura: "",
      id_moneda: "",
      nombre_moneda: "",
      clave_moneda: "",
      simbolo_moneda: "",
      iva: null,
      isr: null,
      iva_retencion: null,
      monto: null
    },

    dialogValidate: false,

    // Objeto para las validaciones de factura
    validaciones: {
      ivaCoincide: null,
      isrCoincide: null,
      ivaRetencionCoincide: null,
      totalCoincide: null
    },

    // Objeto para las validaciones de evidencia
    validacionesEvidencia: {
      esLegible: null,
      correspondeFactura: null,
      estaCompleta: null,
      sinAlteraciones: null
    },

    dialogFactura: false,
    loadingFactura: false,
    loadFacturaError: null,
    urlFactura: null,
    showFacturaPDF: false,

    dialogEvidencia: false,
    loadingEvidencia: false,
    loadEvidenciaError: null,
    urlEvidencia: null,
    showEvidenciaPDF: false,

    downloadUrl: '/api/Pagos/DescargarProgramacionCompraOrdenDocumento',

    rechazo_comentarios: null,
    
    saving: false,
  }),
  mounted(){
    this.getProveedores();
    this.getItems();
  },
  methods: {
    getItems(){
      this.loading = true;
      axios
        .get('/Pagos/ListarProgramacionCompraOrdenFacturasPendientes', {
          params: {
            id_proveedor: this.search.id_proveedor,
            num_programacion_pago_orden: this.search.num_programacion_pago_orden
          }
        })
        .then(response => {
          this.items = response.data || [];
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getProveedores() {
      this.loadingProveedores = true;
      axios
        .get('/Proveedores/ListarProveedores', {
          params: {
            id_proveedor_nivel: '267c7302-72fc-4f96-988a-9ea1d2cf6fef',
            estado: 1
          }
        })
        .then(response => {
          this.proveedores = response.data || [];
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loadingProveedores = false;
        });
    },

    formatMoney(value) {
      if (!value) return '0.00';
      return parseFloat(value).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    getIva(item){
      return item.monto * ((item.iva || 0) / 100.0);
    },

    getIsr(item){
      return item.monto * ((item.isr || 0) / 100.0);
    },

    getIvaRetencion(item){
      return item.monto * ((item.iva_retencion || 0) / 100.0);
    },

    getTotal(item){
      return (item.monto) + (this.getIva(item) || 0.0) - (this.getIsr(item) || 0.0) - (this.getIvaRetencion(item) || 0.0);
    },

    openDialogValidate(item){
      this.dialogValidate = true;
      this.validateItem = item;
      // Resetear estados de revisión
      this.resetValidaciones();
      this.resetValidacionesEvidencia();
    },

    closeDialogValidate(){
      this.dialogValidate = false;
      this.validateItem = Object.assign({}, this.defaultValidateItem);
      this.rechazo_comentarios = null;
      this.resetValidaciones();
      this.resetValidacionesEvidencia();
    },

    resetValidaciones() {
      this.validaciones = {
        ivaCoincide: null,
        isrCoincide: null,
        ivaRetencionCoincide: null,
        totalCoincide: null
      };
    },

    resetValidacionesEvidencia() {
      this.validacionesEvidencia = {
        esLegible: null,
        correspondeFactura: null,
        estaCompleta: null,
        sinAlteraciones: null
      };
    },

    async openDialogFactura() {
      const url = this.getURL(this.validateItem.archivo_factura_pdf);
      if (!url) return;

      this.dialogFactura = true;
      this.loadFacturaError = null;
      this.loadingFactura = false;

      this.showFacturaPDF = this.isPdfFileFromEncryptedName(this.validateItem.archivo_factura_pdf);
      this.urlFactura = url;
    },

    closeDialogFactura(){
      this.dialogFactura = false;
    },

    getURL(fileName) {
      if (!fileName) return null;
      return `${this.downloadUrl}/${fileName}?jwt=${this.token}`;
    },

    async openDialogEvidencia() {
      const url = this.getURL(this.validateItem.archivo_evidencia);
      if (!url) return;

      this.dialogEvidencia = true;
      this.loadEvidenciaError = null;
      this.loadingEvidencia = false;

      this.showEvidenciaPDF = this.isPdfFileFromEncryptedName(this.validateItem.archivo_evidencia);
      this.urlEvidencia = url;
    },

    closeDialogEvidencia() {
      this.dialogEvidencia = false;
      this.urlEvidencia = null;
      this.showEvidenciaPDF = false;
      this.loadEvidenciaError = null;
    },

    getRealExtension(fileName) {
      if (!fileName) return null;
      const parts = fileName.split('.');
      if (parts.length < 2) return null;

      if (parts[parts.length - 1].toLowerCase() === 'enc' && parts.length >= 3) {
        return parts[parts.length - 2].toLowerCase();
      }

      return parts[parts.length - 1].toLowerCase();
    },

    isPdfFileFromEncryptedName(fileName) {
      const ext = this.getRealExtension(fileName);
      return ext === 'pdf';
    },

    saveValidation(){
      this.saving = true;
      axios
      .post('/Pagos/RevisionProgramacionCompraOrdenFactura', {
        id_programacion_compra_order_factura: this.validateItem.id_programacion_compra_orden_factura,
        motivo_rechazo_factura: this.rechazo_comentarios
      })
      .then(() => {
        this.closeDialogValidate();
        this.getItems();
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.saving = false;
      })
    }
  }
}
</script>

<style scoped>
.dialog-card {
  border-radius: 8px;
}

.border-bottom {
  border-bottom: 1px solid #e0e0e0;
}

.border-right {
  border-right: 1px solid #e0e0e0;
}

.section-title {
  font-size: 0.875rem;
  font-weight: 500;
  color: #424242;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.info-field {
  margin-bottom: 8px;
}

.info-label {
  font-size: 0.75rem;
  color: #757575;
  margin-bottom: 4px;
  font-weight: 500;
}

.info-value {
  font-size: 0.875rem;
  color: #212121;
}

.document-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.document-card:hover {
  border-color: #bdbdbd;
}

.document-card--reviewed {
  background-color: #f1f8f4;
  border-color: #4caf50;
}

.status-chip {
  font-size: 0.75rem;
  height: 24px;
}

.validation-panel {
  background-color: #fafafa;
}

.validation-section {
  background-color: white;
  border-radius: 4px;
  padding: 12px;
}

.validation-label {
  line-height: 1.2;
}

.validation-label-evidence {
  display: flex;
  align-items: flex-start;
  line-height: 1.3;
}

.validation-item {
  background-color: #f9f9f9;
  padding: 12px;
  border-radius: 6px;
}

.validation-toggle {
  width: 100%;
}

.validation-toggle .v-btn {
  flex: 1;
}

.validation-toggle .v-btn:not(.v-btn--outlined) {
  color: white !important;
}

.validation-toggle .v-btn:not(.v-btn--outlined) .v-icon {
  color: white !important;
}

.document-info {
  background-color: white;
  border-radius: 4px;
  padding: 12px;
}

.info-item {
  display: flex;
  align-items: center;
}

.amounts-summary {
  background-color: white;
  border-radius: 4px;
  padding: 12px;
}

.pdf-container {
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  max-height: 85vh;
  overflow: auto;
}

.pdf-viewer {
  width: 100%;
  height: calc(100% - 32px);
  max-height: 100%;
}

.opp-scroll-x{
  overflow-x: auto;
  position: relative; /* importante para sticky */
}

/* tu panel */
.validation-col{
  position: sticky;
  left: 0;
  z-index: 5;          /* para que no lo tape el contenido de la derecha */
  background: white;   /* para que no se transparente */
}

/* opcional: una sombrita/borde para separar */
.validation-col{
  box-shadow: 6px 0 10px rgba(0,0,0,.06);
}

.factura-card{
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.factura-toolbar{
  flex: 0 0 auto;
}

/* solo aquí habrá scroll vertical */
.factura-body{
  flex: 1 1 auto;
  min-height: 0;      /* CRÍTICO para que no “empuje” y cause scroll extra */
  overflow-y: auto;
}

.evidencia-card{
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.evidencia-toolbar{
  flex: 0 0 auto;
}

.evidencia-body{
  flex: 1 1 auto;
  min-height: 0;   /* clave para evitar scroll extra */
  overflow-y: auto;
}

</style>s